import { useState, type ReactElement } from "react";

interface Props {
  value: string;
  label?: string;
}

export function CopyButton({ value, label = "Copy" }: Readonly<Props>): ReactElement {
  const [copied, setCopied] = useState(false);

  async function handleClick(): Promise<void> {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 1_500);
    } catch {
      // Clipboard API unavailable (older browsers / insecure context) -
      // surface nothing; the user can manually select the text.
    }
  }

  return (
    <button
      type="button"
      className="btn btn-secondary px-3 py-1.5 text-xs"
      onClick={() => {
        void handleClick();
      }}
      aria-label={`${label}: ${value}`}
    >
      <i className={copied ? "ti ti-check text-sm" : "ti ti-copy text-sm"} />
      {copied ? "Copied" : label}
    </button>
  );
}
